import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Typography,
  message,
} from "antd";
import {InputFields} from "components/common";
import {FIELD_TYPE} from "types/enums";

const {INPUT} = FIELD_TYPE;
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {useAppSelector} from "redux/hooks";
import shoppingService from "api/shopping";
const css = {xs: 24, sm: 24, md: 24, lg: 24, xl: 24};
const wrapperCol = {xs: 14, md: 16, xl: 20, lg: 20};
const labelCol = {xs: 10, md: 8, xl: 4, lg: 4};
const ModalDeny = forwardRef((props: any, ref) => {
  const {selectedRowKeys, getData, closeModal} = props;
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const fields = [
    {
      label: "Lý do",
      name: "lyDoTuChoi",
      type: INPUT,
      css: css,
      wrapperCol,
      labelCol,
      rules: [{required: true, message: "Chưa nhập lý do"}],
    },
  ];
  useImperativeHandle(ref, () => ({
    resetFields: () => {
      form.resetFields();
    },
  }));
  const submitDeny = async () => {
    try {
      const values = await getFormValues();
      if (values) {
        setIsLoading(true);
        const data = {
          listId: selectedRowKeys,
          lyDoTuChoi: values?.lyDoTuChoi,
        };
        const res = await shoppingService.denyListProposeShopping(data);
        setIsLoading(false);
        closeModal();
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };
  const getFormValues = async () => {
    try {
      const formValues = await form.validateFields();
      return formValues;
    } catch (error) {
      return null;
    }
  };
  return (
    <Spin spinning={isLoading}>
      <Form labelCol={{span: 8}} wrapperCol={{span: 14}} form={form}>
        <Row style={{width: "100%"}}>
          <InputFields data={fields}></InputFields>
        </Row>
      </Form>
      <Row justify={"end"} style={{marginTop: 8}}>
        <Space>
          <Button onClick={closeModal}>Hủy</Button>{" "}
          <Button type="primary" onClick={submitDeny}>
            Xác nhận
          </Button>
        </Space>
      </Row>
    </Spin>
  );
});

export default ModalDeny;
